import "../chunk-PKUHTIDK.js";
import {
  processIndex,
  calculateTranslate,
  translateItem,
  handleItemClick,
  computedTransform,
  resetAnimatingMf,
  setDelta
} from "./index";
const api = [
  "state",
  "hover",
  "translate",
  "scale",
  "active",
  "ready",
  "inStage",
  "animating",
  "isOblique",
  "hasTitle",
  "getTransform",
  "processIndex",
  "calculateTranslate",
  "translateItem",
  "handleItemClick",
  "resetAnimatingMf",
  "setDelta"
];
const renderless = (props, { computed, onMounted, onUnmounted, reactive }, { parent, dispatch }) => {
  const api2 = {};
  const CARD_SCALE = parent.$constants.CARD_SCALE;
  const TYPE_VERTICAL = parent.$constants.TYPE_VERTICAL;
  const state = reactive({
    scale: 1,
    translate: 0,
    hover: false,
    ready: false,
    active: false,
    inStage: false,
    animating: false,
    animatingMf: false,
    isOblique: false,
    carouselParent: parent.$parent,
    hasTitle: computed(() => !!props.title),
    moving: computed(() => parent.$parent.state.moving),
    animate: computed(() => Math.abs(parent.$parent.state.delta) > 0 ? !state.animatingMf : state.animating),
    getTransform: computed(() => api2.computedTransform(state)),
    delta: 0
  });
  Object.assign(api2, {
    state,
    processIndex,
    handleItemClick: handleItemClick(parent),
    computedTransform: computedTransform({ parent, TYPE_VERTICAL }),
    calculateTranslate: calculateTranslate({ CARD_SCALE, state }),
    translateItem: translateItem({ api: api2, CARD_SCALE, parent, state }),
    setDelta: setDelta({ state }),
    resetAnimatingMf: resetAnimatingMf(state)
  });
  onMounted(() => {
    dispatch("Carousel", "updateItems", []);
    dispatch("Carousel", "complete", []);
  });
  onUnmounted(() => {
    parent.$parent && parent.$parent.updateItems();
  });
  return api2;
};
export {
  api,
  renderless
};
